"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Shortcuts_1 = require("./Shortcuts");
var onShortcut = function (name, listener, deps) {
    var shortcuts = (0, Shortcuts_1.useShortcuts)();
    var listenerCallback = (0, react_1.useCallback)(listener, deps);
    (0, react_1.useEffect)(function () {
        shortcuts.on(name, listenerCallback);
        return function () { return shortcuts.off(name, listenerCallback); };
    }, [listenerCallback]);
};
exports.default = onShortcut;
